import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M6.654 13.333c0 .354.142.693.395.943a1.353 1.353 0 0 0 1.903 0c.253-.25.395-.589.395-.943M13.834 12s-1.346-2.222-1.346-4V5.778c0-1.179-.473-2.31-1.315-3.143A4.5 4.5 0 0 0 8 1.333a4.5 4.5 0 0 0-3.173 1.302 4.42 4.42 0 0 0-1.314 3.143V8c0 1.778-1.346 4-1.346 4z" }, null, -1)
  ]))]))
}
export default { render: render }